import React, { useEffect, useMemo, useState } from "react";
import CustomTable from "../../ui/custom-table";
import { SetPopupReducerData } from "../../store/reducer/PopupReducer";
import { formatTime } from "../../utils/common";
import { useDispatch, useSelector } from "react-redux";
import { fetchTeamMmebers, TeamMemberStatusChange } from "../../api/api";

function TeamMember() {
  const dispatch = useDispatch();
  const [Data, setData] = useState([]);
  const [loading, setLoading] = useState(false);
  const { data } = useSelector((state) => state?.authUser);
  const user_info = data?.data;
  const org_id = user_info?.organization_id;
  const editUserData = useSelector(
    (state) => state?.PopupReducer?.modal?.showModal
  );

  const fecthMembers = async () => {
    try {
      setLoading(true);
      const data = await fetchTeamMmebers(org_id);
      console.log(data, "data");
      setData(data?.data?.data);
    } catch (error) {
      console.log("error", error);
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    fecthMembers();
  }, []);

  const handleStausChange = async (id, status) => {
    let payload = {
      status: status === true ? false : true,
    };
    try {
      const data = await TeamMemberStatusChange(id, payload);
      if (data?.data?.status === true) {
        fecthMembers();
      }
    } catch (error) {
      console.error("Error updating status:", error);
    }
  };

  const columns = useMemo(
    () => [
      { accessorKey: "user_name", header: "Name" },
      {
        accessorKey: "email",
        header: "Email Id",
      },
      {
        accessorKey: "mobile_number",
        header: "Phone no.",
      },
      {
        accessorKey: "Status",
        header: "status",
        Cell: ({ row }) => {
          const isActive = row.original.status;

          return (
            <div className="d-flex align-items-center gap-2">
              <label className="custom-toggle mb-0">
                <input
                  type="checkbox"
                  checked={isActive}
                  onChange={() => handleStausChange(row.original._id, isActive)}
                />
                <span className="slider"></span>
              </label>
              <span
                className={`fw-bold ${
                  isActive ? "text-success" : "text-danger"
                }`}
              >
                {isActive ? "Disable " : "Enable"}
              </span>
            </div>
          );
        },
      },
      {
        accessorKey: "updated_at",
        header: "Date",
        Cell: ({ cell }) => formatTime(cell.getValue()),
      },
    ],
    []
  );

  const handleAddClick = () => {
    dispatch(
      SetPopupReducerData({
        modalType: "InviteUser",
        showModal: true,
      })
    );
  };

  const handleEdit = (row) => {
    dispatch(
      SetPopupReducerData({
        modalType: "InviteUser",
        showModal: true,
        data: row,
      })
    );
  };

  useEffect(() => {
    if (!editUserData) {
      fecthMembers();
    }
  }, [editUserData]);
  return (
    <div>
      {" "}
      <aside className="mainSection">
        <CustomTable
          columns={columns}
          data={Data}
          loading={loading}
          onAddClick={handleAddClick}
          addButtonLabel="Add Member"
          showActions={true}
          onEdit={handleEdit}
        />
      </aside>
    </div>
  );
}

export default TeamMember;
